import React, { PropsWithChildren } from 'react';

import { Note } from '../note/note';

import styles from './settings-table.module.scss';

interface SettingsTableProps extends React.PropsWithChildren {
  headers: string[];
  isFullHeight?: boolean;
  hint?: string;
}

export const SettingsTable: React.FC<PropsWithChildren<SettingsTableProps>> = ({
  headers,
  children,
  isFullHeight,
  hint,
}) => (
  <div className={styles['container']}>
    {hint && <Note isFullWidth>{hint}</Note>}

    <div className={styles['table']} data-fullHeight={isFullHeight}>
      {!isFullHeight && (
        <div className={styles['table-header']}>
          {headers.map((header) => (
            <div className={styles['cell']} key={`header_${header}`}>
              {header}
            </div>
          ))}
        </div>
      )}
      {children}
    </div>
  </div>
);
